export const ENDPOINTS = {
  getRooms: '/gateway/builder/:id/rooms',
  createRoom: '/gateway/builder/:id/rooms',
  updateRoom: '/gateway/builder/:id/rooms/:roomId',
  getExperiences: '/gateway/builder/:id/experiences',
  updateExperience: '/gateway/builder/:id/experiences/:experienceId',
} as const;

export const CORE_QUERY_KEYS = {
  builderRooms: 'builder-rooms',
  builderExperiences: 'builder-experiences',
} as const;
